import theme from "@/theme";

export const styles = {
  modalBase: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "47.1255rem",
    height: "273px",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    padding: "1.75rem 2.5rem ",
    borderRadius: "1.5rem",
  },

  modalReply: {
    position: "absolute",
    top: "80px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "796px",
    minHeight: "470px",
    bgcolor: "#FFFFFF",
    borderRadius: "20px",
    borderTop: "1px solid #D5D8DB",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },

  parentContainer: {
    width: "756px",
    minHeight: "186px",
    display: "flex",
    flexDirection: "column",
  },

  parentHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    height: "58px",
  },

  parentAvatar: {
    width: "58px",
    height: "58px",
    borderRadius: "48px",
  },

  parentUserInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: "row",
  },

  parentUsername: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
    letterSpacing: "2%",
    color: "#2A2D31",
  },

  parentTime: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: theme.palette.custom.blueGray600,
  },

  parentCommentBox: {
    width: "756px",
    minHeight: "128px",
    paddingLeft: "58px",
  },
  parentCommentText: {
    color: theme.palette.custom.blueGray900,
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0%",
  },
  parentCommentInner: {
    width: "698px",
    minHeight: "128px",
    borderRadius: "16px",
    padding: "16px",
    border: "1px solid #F4F5F6",
    color: theme.palette.custom.blueGray900,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },

  button: {
    width: "78px",
    height: "40px",
    borderRadius: "8px",
    padding: "8px 16px",
    textTransform: "none",
    opacity: 1,
    "&:disabled": {
      backgroundColor: "#8FBDF9",
      color: "#fff",
    },
  },
  header: {
    position: "relative",
    width: "100%",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 ",
    boxSizing: "border-box",
    opacity: 1,
  },
  closeButtonBase: {
    position: "relative",
    marginLeft: "auto",
    padding: 0,
  },
  closeButtonReply: {
    position: "relative",
    marginRight: "auto",
    padding: 0,
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "155%",
    letterSpacing: "-1%",
    textAlign: "center",
    flexGrow: 1,
  },
  editorContainer: {
    width: "100%",
    position: "relative",
    p: "0.5rem",
    minHeight: "5.625rem",
    height: "162px",
    bgcolor: theme.palette.custom.blueGray100,
    borderRadius: "0.75rem",
    pb: "3rem",
  },
  editorInner: {
    maxHeight: "5.9rem",
    overflowY: "auto",
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "15px !important",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: theme.palette.custom.blueGray900,
  },
  editorBottomBar: {
    position: "absolute",
    bottom: 0,
    direction: "row",
    alignItems: "center",
    width: "calc(100% - 8px)",
    justifyContent: "space-between",
    pr: "0.5rem",
    pb: "0.5rem",
  },
  emojiStack: {
    direction: "row",
    alignItems: "center",
    gap: "1rem",
  },
  counterAndButtonBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 5px",
    gap: 2.5,
  },
  userAvatar: {
    width: "46px",
    height: "46px",
    borderRadius: "40px",
  },
  counter: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "13px",
    lineHeight: "24px",
    letterSpacing: "-0.01em",
    color: "#7D8690",
  },
  mentionStyle: {
    color: theme.palette.custom.mainBlue,
    fontFamily: "Inter",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-1%",
  },
};
